import React from 'react';
import QuoteBuilderForm from 'components/quote_builder/QuoteBuilderForm.jsx';

const FlexoPrintingAndDieCutting = ({ config, disabled, options, uuid, item, extra_item_title, navSection, colIndex, rowIndex, getExtraItems, disabledReason, navSectionColumnType }) => {
  return (
    <div>
      <QuoteBuilderForm
        config={config.flexo_printing_and_die_cutting}
        disabled={disabled}
        disabledReason={disabledReason}
        options={options}
        section_uuid={uuid}
        navSectionColumnType={navSectionColumnType}
        item={item}
        extra_title={extra_item_title}
        getExtraItems={getExtraItems}
        navSection={navSection}
        colIndex={colIndex}
        rowIndex={rowIndex}
      />
    </div>
  )
}

export default FlexoPrintingAndDieCutting;
